export const MockCartItems = [{
    itemId: '2d3b675ea857dc41158bad3b28300824',
    itemHeight: 500,
    itemWidth: 885,
    itemType: 'image',
    imageUrl: 'https://static.wixstatic.com/media/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg/v1/fit/w_250,h_250,al_c,q_90/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    itemUrl: '293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    selectedLicenseId: '58cf864dbb0ce6322f2c5a60',
    selectedQualityId: '58cf864dbb0ce6322f2c5a62',
    galleryId: '3e893583-033b-4b48-80c8-03038156d3f9',
    uuid: 'b281a1ed-c24b-422d-af59-686417d556f7'
  },
  {
    itemId: '2d3b675ea857dc41158bad3b28300824',
    itemHeight: 500,
    itemWidth: 885,
    itemType: 'image',
    imageUrl: 'https://static.wixstatic.com/media/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg/v1/fit/w_250,h_250,al_c,q_90/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    itemUrl: '293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    selectedLicenseId: '58cf864dbb0ce6322f2c5a60',
    selectedQualityId: '58cf864dbb0ce6322f2c5a62',
    galleryId: '3e893583-033b-4b48-80c8-03038156d3f9',
    uuid: '58900d12-78cf-407b-8237-a4b1abf21b38'
  },
  {
    itemId: '2d3b675ea857dc41158bad3b28300824',
    itemHeight: 500,
    itemWidth: 885,
    itemType: 'image',
    imageUrl: 'https://static.wixstatic.com/media/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg/v1/fit/w_250,h_250,al_c,q_90/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    itemUrl: '293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    selectedLicenseId: '58cf864dbb0ce6322f2c5a60',
    selectedQualityId: '58cf864dbb0ce6322f2c5a62',
    galleryId: '3e893583-033b-4b48-80c8-03038156d3f9',
    uuid: '7d192411-b97a-452f-a872-ae6700d98395'
  },
  {
    itemId: '2d3b675ea857dc41158bad3b28300824',
    itemHeight: 500,
    itemWidth: 885,
    itemType: 'image',
    imageUrl: 'https://static.wixstatic.com/media/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg/v1/fit/w_250,h_250,al_c,q_90/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    itemUrl: '293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    selectedLicenseId: '58cf864dbb0ce6322f2c5a60',
    selectedQualityId: '58cf864dbb0ce6322f2c5a62',
    galleryId: '3e893583-033b-4b48-80c8-03038156d3f9',
    uuid: '273c5017-0bcc-4ab3-81a6-0506533d83e8'
  },
  {
    itemId: '2d3b675ea857dc41158bad3b28300824',
    itemHeight: 500,
    itemWidth: 885,
    itemType: 'image',
    imageUrl: 'https://static.wixstatic.com/media/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg/v1/fit/w_250,h_250,al_c,q_90/293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    itemUrl: '293387_6ce02756125d4c329ba73da0c0a83624~mv2.jpg',
    selectedLicenseId: '58cf864dbb0ce6322f2c5a60',
    selectedQualityId: '58cf864dbb0ce6322f2c5a62',
    galleryId: '3e893583-033b-4b48-80c8-03038156d3f9',
    uuid: '6eb31f96-9122-455d-8e11-22a8c382e1f7'
  }
];

export const isDemoLocal = () => {
  if (process.env.NODE_ENV === 'development') {
    try {
      return ((window.top.location.href === window.location.href) && window.location.href.indexOf('local.wix.com') >= 0)
    } catch (e) {
      return false;
    }
  } else {
    return false;
  }
}
